import * as React from 'react';

import {getEditionStatusInfo} from 'shells/edition/get-edition-status-info';
import {ClockIcon, TickCircleIcon} from 'shells/icon';
import {StatusBadge, getFillColor} from 'shells/status-badge/status-badge';

import type {NutshellMarketingStartTriggerFragment} from 'nutshell-graphql-types';

import styles from './closed-lead-drip-sequence-start-trigger-card.module.css';

type Props = {
    startTrigger: NutshellMarketingStartTriggerFragment;
};

/*
 * Component that represents a single step template card on the sales process.
 */
export class DripSequenceStartTriggerCard extends React.PureComponent<Props> {
    render() {
        const {startTrigger} = this.props;
        const {campaign} = startTrigger;

        // this ternary is to get around flow - it will always be a drip sequence,
        // but Flow wants to be sure. We are using __typename instead of type because
        // Flow is confused when we use type and this is what works.
        const statusInfo =
            campaign.type === 'DRIP_SEQUENCE' ? getEditionStatusInfo(campaign.status) : undefined;
        const fillColor = statusInfo ? getFillColor(statusInfo.level) : undefined;

        if (campaign.type === 'DRIP_SEQUENCE') {
            return (
                <div className='flex flex-dir-col align-start max-full-width'>
                    <div className={styles['top-line-container']}>
                        <div
                            style={{backgroundColor: fillColor}}
                            className={styles['card-border']}
                        />
                        <div className='flex max-full-width align-center'>
                            <div className={styles.title}>{campaign.name}</div>
                            <div className={styles.status}>
                                |
                                {statusInfo ? (
                                    <div className={styles['status-badge-container']}>
                                        <StatusBadge {...statusInfo} />
                                    </div>
                                ) : undefined}
                            </div>
                        </div>
                    </div>
                    {campaign.startTriggerDelayText ? (
                        <div className={styles['delay-container']}>
                            <ClockIcon size={13} />
                            {campaign.startTriggerDelayText}
                        </div>
                    ) : undefined}
                    {campaign.goal ? (
                        <div className={styles['goal-container']}>
                            <TickCircleIcon size={11} className={styles['tick-circle-icon']} />
                            {campaign.goal.humanReadableTitle}
                            {campaign.isStopOnGoal ? ' • Stop sending if met' : undefined}
                        </div>
                    ) : undefined}
                </div>
            );
        }

        // We only allow start triggers on drip sequences, so this is very
        // confusing if this ever occurs
        return null;
    }
}
